<template>
  <div class="modal">
    <div class="modal-body">
      <p class="intro">
        Thank you for using this secure application to initiate your payment(s).
        Here's how the process works:
      </p>

      <!-------------City of Romulus---7/8/2026 Ticket#--------------------------------------------------------->
      <div v-if="$store.state.account_number.indexOf('0018437') > -1">
        <!-- ───── Using your bank account ───── -->
        <section class="section">
          <h2 class="section-link" style="font-size: 16px">
            Using your bank account
          </h2>

          <div class="subsection">
            <p>
              <b>If Your Bank Account Information is Not Saved in MyEnroll360</b
              >, you must add bank account information to set up
              <span style="color: red">
                <strong>recurring monthly payments</strong></span
              >
              for your ongoing benefits.
            </p>
            <p>
              <b>If You Want to Change Your Bank Account Information</b>, you
              can do so by clicking on the “View Bank Account” box and click on
              “Change Bank Account”. You may then add and save your new account
              information.
            </p>
          </div>
        </section>

        <!-- ───── Payment and account confirmation ───── -->
        <section class="section">
          <h3 class="subsection-title">Confirmation of Bank Account Setup</h3>

          <div class="subsection">
            <ul>
              <li>
                After setting up your ACH Debit payment, MyEnroll360 will email
                you to confirm your bank account details and payment
                authorization.
              </li>
              <li>
                To avoid emails going to your junk folder, add
                <strong>Benefit Allocation Systems (BAS)</strong> and the
                following email addresses to your contacts:
              </li>
            </ul>
            <p class="email-highlight">service@MyEnroll.com</p>
          </div>

          <div class="subsection">
            <h3 class="subsection-title">
              Confirmation of Payment Applied to Your Account
            </h3>
            <ul>
              <li>
                BAS will send you an email confirming receipt of your payment
                once it processes and clears the U.S. ACH system (typically 1-3
                business days). The email will also confirm that the payment has
                been applied to your account in MyEnroll360.
              </li>
            </ul>
          </div>
        </section>

        <hr class="divider" />

        <!-- ───── How ACH debits work ───── -->
        <section class="section">
          <h2 class="section-link">How ACH Debits Work</h2>
          <p>
            Your payment authorization will be processed through the U.S.
            Banking ACH system. Payments initiated today (if a business day)
            will be processed this evening. Payments processed on non-business
            days will be processed the next business day.
          </p>
          <p>
            ACH payments typically take up to
            <strong>3 business days</strong> to debit your account and deliver
            funds to BAS. You will see your payment applied in MyEnroll360 once
            the ACH transaction is fully completed.
          </p>
        </section>
      </div>

      <!------------------------------------------------------------------->
      <div v-else>
        <!-- ───── Using your bank account ───── -->
        <section class="section">
          <h3 class="section-link">Using your bank account</h3>

          <div class="subsection">
            <h4 class="subsection-title">
              Your bank account is already saved in MyEnroll360
            </h4>
            <ul>
              <li>
                If a bank account is already set up in MyEnroll360, you can
                choose to use that account or enter a different one for this
                transaction.
              </li>
              <li>
                Any bank account details you enter or update here will be saved
                to your MyEnroll360 profile, replace your existing bank account
                information, and used for future payments.
              </li>
            </ul>
          </div>

          <div class="subsection">
            <h4 class="subsection-title">
              Your bank account is not yet saved in MyEnroll360
            </h4>
            <ul>
              <li>
                If no bank account is on file, you can add your bank account
                details here to complete your payment.
              </li>
              <li>
                Your bank account information will be securely saved in
                MyEnroll360 and can be used for future payments.
              </li>
              <li>
                To manage or update your saved bank account at any time, log in
                to
                <a
                  :href="$store.state.myenroll_url"
                  target="_blank"
                  rel="noopener"
                  >MyEnroll360</a
                >
                and use the Manage ACH preferences quick link.
              </li>
            </ul>
          </div>

          <div class="subsection">
            <h4 class="subsection-title">
              If your account is set up for recurring ACH payments new
            </h4>
            <ul>
              <li>
                If your account is enrolled in recurring ACH, the bank details
                you provide will be saved as your recurring payment method.
              </li>
              <li>
                Future monthly payments will be automatically debited from the
                account on file.
              </li>
              <li>
                Any changes you make to your bank account here will take effect
                immediately for all future recurring payments.
              </li>
              <li>
                To stop or modify recurring payments, log in to

                <a
                  :href="$store.state.myenroll_url"
                  target="_blank"
                  rel="noopener"
                  >MyEnroll360</a
                >
                and use the Manage ACH preferences quick link, or contact your
                plan administrator, if available.
              </li>
            </ul>
          </div>
        </section>

        <hr class="divider" />

        <!-- ───── Paying for multiple periods ───── -->
        <section class="section">
          <h3 class="section-link">Paying for multiple payment periods</h3>
          <ul>
            <li>
              If you owe for multiple payment periods, you can choose to pay
              one, some, or all outstanding amounts.
            </li>
            <li>
              You must first pay the oldest due amounts in full before selecting
              more recent ones. The application will guide you through the
              process to ensure proper payment allocation.
            </li>
          </ul>
        </section>

        <hr class="divider" />

        <!-- ───── Payment and account confirmation ───── -->
        <section class="section">
          <h3 class="section-link">Payment and account confirmation</h3>

          <div class="subsection">
            <h4 class="subsection-title">Confirmation of bank account setup</h4>
            <ul>
              <li>
                After setting up your ACH debit payment, MyEnroll360 will email
                you to confirm your bank account details and payment
                authorization.
              </li>
              <li>
                To avoid emails going to your junk folder, add
                <strong>Benefit Allocation Systems (BAS)</strong> and the
                following email address to your contacts:
              </li>
            </ul>
            <p class="email-highlight">service@MyEnroll.com</p>
          </div>

          <div class="subsection">
            <h4 class="subsection-title">
              Confirmation of payment applied to your account
            </h4>
            <ul>
              <li>
                BAS will send you an email confirming receipt of your payment
                once it clears the U.S. ACH system (typically 1–3 business
                days). The email will also confirm that the payment has been
                applied to your account in MyEnroll360.
              </li>
            </ul>
          </div>
        </section>

        <hr class="divider" />

        <!-- ───── How ACH debits work ───── -->
        <section class="section">
          <h3 class="section-link">How ACH debits work</h3>
          <ul>
            <li>
              Your payment authorization will be processed through the U.S.
              Banking ACH system.
            </li>
            <li>
              Payments initiated:
              <ul class="nested-list">
                <li>
                  Today (during regular business hours, Eastern Time): Processed
                  this evening.
                </li>
                <li>
                  Non-business day or outside regular business hours, Eastern
                  Time: Processed on the next business day.
                </li>
              </ul>
            </li>
            <li>
              ACH payments typically take up to 3 business days to debit your
              account and deliver funds to BAS to apply to your
              employer’s/former employer’s/benefits program’s account.

              <!-- ACH payments typically take up to
            <strong>3 business days</strong> to debit your account and deliver
            funds to BAS. -->
            </li>
            <li>
              You will see your payment applied in MyEnroll360 once the ACH
              transaction is fully completed.
            </li>
          </ul>
        </section>
      </div>
      <!------------------------------------------------------------------------------------------->

      <hr class="divider" />

      <!-- ───── Need help ───── -->
      <section class="section">
        <h4 style="color: #0f4761; font-weight: bold; margin-top: 10px">
          Need Help?
        </h4>
        <p style="margin-top: 10px">
          For questions or assistance, contact BAS at:
        </p>
        <ul>
          <li>
            <strong>Office Hours:</strong>
            Monday - Friday 8:30 AM - 5:00 PM Eastern Time
            <strong>(Except Federal Holidays)</strong>
          </li>
          <li>
            <strong>Email:</strong>
            {{ $store.state.service_email }}
          </li>
          <li>
            <strong>Phone:</strong>
            {{ $store.state.service_phone }}
          </li>
        </ul>
        <p class="footer-msg">
          <strong style="margin-top: 10px; color: #7030a0; font-weight: bold">
            We appreciate your payment and look forward to assisting you
            further!
          </strong>
        </p>
      </section>
    </div>
  </div>
  <!-- </div> -->
</template>

<script>
export default {
  data() {
    return { service_data: [] };
  },
  mounted() {
    this.employee_number = this.$store.state.employee_number;
    //this.Get_ee_serviceph_email();
  },
  computed: {
    methodUrl() {
      const href = location.href.toLowerCase();
      if (href.indexOf("bas1.myenroll") > -1) {
        return "https://www.bas1.myenroll.com";
      } else if (href.indexOf("temp.bastest") > -1) {
        return "https://www.temp.bastest.com";
      } else if (href.indexOf("localhost") > -1) {
        return "http://localhost/web_projects";
      } else {
        return "";
      }
    },
  },
};
</script>

<style scoped>
/* ── Overlay ── */
.modal-overlay {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.45);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
}

/* ── Modal container ── */
.modal {
  background: #ffffff;

  width: 99%;

  max-height: 88vh;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

/* ── Header ── */
.modal-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 14px 20px;
  border-bottom: 1px solid #e0e0e0;
  flex-shrink: 0;
}

.modal-header h2 {
  font-size: 16px;
  font-weight: 600;
  color: #1a1a1a;
  margin: 0;
}

.close-btn {
  background: #f0f0f0;
  border: none;
  border-radius: 50%;
  width: 28px;
  height: 28px;
  cursor: pointer;
  font-size: 14px;
  color: #555;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: background 0.15s;
}

.close-btn:hover {
  background: #e0e0e0;
}

/* ── Scrollable body ── */
.modal-body {
  padding: 20px 24px;
  overflow-y: auto;
  font-size: 13px;
  line-height: 1.65;
  color: #333;
}

.intro {
  margin-bottom: 16px;
  color: #444;
}

/* ── Sections ── */
.section {
  margin-bottom: 4px;
}

.section-link {
  color: #1c3f90;
  font-size: 13px;
  font-weight: 600;
  margin-bottom: 10px;
  margin-top: 4px;
}

.subsection {
  margin-bottom: 14px;
}

.subsection-title {
  font-size: 13px;
  font-weight: 600;
  color: #1a1a1a;
  margin-bottom: 6px;
}

/* ── Recurring ACH highlighted subsection ── */
.subsection--recurring {
  background: #f3faf0;
  border: 1px solid #b7dba1;
  border-radius: 6px;
  padding: 12px 14px;
}

.subsection--recurring .subsection-title {
  color: #2e6b1f;
}

.subsection--recurring ul li {
  color: #2e6b1f;
}

.subsection--recurring a {
  color: #1a5c9e;
}

/* ── Lists ── */
ul {
  padding-left: 20px;
  margin: 0;
}

li {
  margin-bottom: 5px;
  color: #444;
}

.nested-list {
  margin-top: 4px;
}

/* ── Email highlight ── */
.email-highlight {
  margin-top: 6px;
  margin-left: 20px;
  font-size: 13px;
  color: #1a1a1a;
  font-weight: 500;
}

/* ── Help section ── */
.help-intro {
  margin-bottom: 6px;
  color: #444;
}

/* ── Divider ── */
.divider {
  border: none;
  border-top: 1px solid #e8e8e8;
  margin: 16px 0;
}

/* ── Links ── */
a {
  color: #1a5c9e;
  text-decoration: none;
}

a:hover {
  text-decoration: underline;
}

/* ── Footer message ── */
.footer-msg {
  text-align: center;
  color: #1a5c9e;
  font-weight: 600;
  font-size: 13px;
  margin-top: 16px;
  padding-bottom: 4px;
}
</style>
